<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome da criança"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :item-class="getRowColor"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="index"
          show-expand
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:header.cfcp="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Número identificador do cidadão no e-SUS. Na falta dessa informação, atualizar o cadastro FCI ou Cidadão."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:item.cfcp="{ item }">
            <div v-if="item.cfcp == null">
              <i class="icofont-warning"></i>
            </div>
            <div v-else>
              {{ item.cfcp }}
            </div>
          </template>
          <template v-slot:item.nu_cpf="{ item }">
            <show-hide-field :value="item.nu_cpf"></show-hide-field>
          </template>
          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }} ({{ item.idade_anos }}
            {{ item.idade_anos == 1 ? 'ano' : 'anos' }})
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="7">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Cadastrado por</th>
                    <th>Suporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ item.nu_cpf }}
                    </td>
                    <td>
                      {{ item.nu_cns }}
                    </td>
                    <td>
                      {{ item.no_profissional }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <div class="doses-list">
                <h4>HPV:</h4>
                <div
                  class="doses-list-item"
                  v-for="n in item.coresHpv.length"
                  :key="n"
                  :class="item.coresHpv[n - 1].cor"
                  @click="onClickDose(item.coresHpv[n - 1], item)"
                >
                  <strong>{{ item.coresHpv[n - 1].dose }}</strong>
                  <span>
                    {{ item.coresHpv[n - 1].dt_plc_br }}
                  </span>
                </div>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card>

      <SalvarVacinaModal
        v-model="modalShow"
        title="HPV Quadrivalente"
        :item="cidadao"
        :dose="selectedDose"
        :mode="mode"
        @saved="$emit('saved', $event)"
        @updated="$emit('updated', $event)"
      />
    </div>
  </v-app>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import SalvarVacinaModal from '@/pages/Imunizacao/components/SalvarVacinaModal.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    SalvarVacinaModal,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        { text: '', value: 'data-table-expand' },
      ],
      modalShow: false,
      selectedDose: null,
      mode: 'create',
      cidadao: null,
    }
  },
  computed: {
    indexedItems() {
      return Functions.formatarCadastrosComDoses(this.cadastros).map(
        (item, index) => ({
          index: index,
          ...item,
        })
      )
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     */
    getRowColor(item) {
      if (item.coresHpv.find((element) => element.cor === 'red')) {
        return `table-row-color-red`
      } else {
        return `table-row-color-green`
      }
    },

    /**
     * Manipula o clique em uma dose de vacina.
     * Define o cidadão selecionado e abre o modal para criação ou edição da dose.
     * @param {Object} dose Dados da dose selecionada
     * @param {Object} item Dados do cidadão
     */
    onClickDose(dose, item) {
      if (!dose) return

      this.cidadao = item

      // só insere se for white ou red
      if (dose.cor === 'white' || dose.cor === 'red') {
        this.mode = 'create'
        this.selectedDose = dose
        this.modalShow = true
        return
      }

      // edição depende de orig==3
      this.mode = 'edit'
      this.selectedDose = dose
      this.modalShow = true
    },
  },
}
</script>

<style scoped lang="scss">
.doses-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  gap: 20px;
  margin: 20px 0;
  background-color: #f1f0f5;
  padding: 15px;
  h4 {
    font-size: 16px;
    margin-bottom: 0;
    width: 15%;
  }
  .doses-list-item {
    background-color: #fff;
    min-width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    border: 1px solid #ccc;
    color: #000;
    border-radius: 6px;
    cursor: pointer;
    &.red {
      background: #ffb3b3 !important;
      // border-color: #990000 !important;
    }
    &.green {
      background: #b3ffb3;
      // border-color: #008000 !important;
    }
    &.white {
      background: #fff;
      // border-color: #000 !important;
    }
  }
}
</style>
